module.exports = __webpack_public_path__ + "static/media/tottori.91464891.png";